export * from './declaration-modal.component'